<script>
import SideBar from '@/components//SideBar';
import NavBar from '@/components/NavBar';
import Footer from '@/components/Footer';

export default {
  name: 'ApplicationLayout',
  components: {
    SideBar,
    NavBar,
    Footer,
  },
  data() {
    return {
    };
  },
  computed: {
    breadcrumbs() {
      return this.$store.state.breadcrumbs;
    },
  },
};
</script>

<template lang="pug">
.application
  .header
    NavBar
  .main
    .breadcrumb
      el-breadcrumb(separator="/")
        el-breadcrumb-item(v-for="(breadcrumb, index) in breadcrumbs" :key="index" :to="breadcrumb.path") {{breadcrumb.name}}
    .side-menu
      SideBar
    .main-content
      slot
  .footer
    Footer
</template>

<style lang="stylus" scoped>
.application
  width 100%
  height 100vh
  padding 60px 0px 123px
  position relative
  background #f4f5f5
  .header
    width 100%
    position fixed
    top 0
    left 0
    z-index 9
  .main
    width 100%
    max-width 1170px
    min-width 1170px
    height 100%
    display flex
    margin 0px auto
    padding 42px 0px 20px
    position relative
    .breadcrumb
      padding 14px 0px
      position absolute
      top 0px
      left 0px
    .side-menu
      width 200px
      height 100%
    .main-content
      width 100%
      height 100%
      overflow auto
      background #fff
      border-left 1px #eaeefb solid
      box-shadow 10px 2px 20px rgba(0, 0, 0, 0.1)
  .footer
    width 100%
    position fixed
    bottom 0px
    left 0px
</style>



// WEBPACK FOOTER //
// CenterLayout.vue?777e80a6